import script from "./OptimizationActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptimizationActivity.vue?vue&type=script&lang=ts&setup=true"

import "./OptimizationActivity.vue?vue&type=style&index=0&id=7252a054&lang=scss"

const __exports__ = script;

export default __exports__